import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { Agreement } from "@/types";
import { FormCreateAgreement } from "./form-create-agreement";
import { FormUpdateAgreement } from "./form-update-agreement";

type FormRolesProps = PropsWithChildren & {
  agreement?: Agreement;
  disable?: boolean;
};

export function FormAgreements({ children, agreement, disable }: FormRolesProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={agreement ? "Atualizar convênio" : "Novo convênio"}
      description={
        agreement
          ? "Preencha os campos para atualizar o convênio."
          : "Preencha os campos para criar um novo convênio."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
      disable={disable}
    >
      {agreement ? (
        <FormUpdateAgreement
          agreement={agreement}
          handleClose={() => setOpen(false)}
        />
      ) : (
        <FormCreateAgreement handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
